import type { EventType } from "@/modules/events/types/client"

import { COMPANY_ADMIN_ROLES, RECRUITER_ADMIN_ROLES, SCHOOL_ADMIN_ROLES } from "@/modules/user/api/types"

export const EVENT_TYPES = [
  "association",
  "chat",
  "coaching",
  "conference",
  "contest",
  "meeting",
  "networking",
  "podcast",
  "recruitment",
  "video",
  "visit",
  "workshop",
] as const

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const EVENT_KINDS = EVENT_TYPES.map(eventType => `event_kind_${eventType}`) as `event_kind_${EventType}`[]

export const EXTERNAL = "external"
export const WITHOUT_REGISTRATION = "without_registration"
export const JOBTEASER = "jobteaser"

export const ADDRESS = "address"
export const CAMPUS = "campus"
export const ONLINE = "online"

export const NO_SPOTS_LEFT = 0

/* Event registration status */
export const REGISTRATION_STATUS_SUBSCRIBED = "REGISTRATION_STATUS_SUBSCRIBED"
export const REGISTRATION_STATUS_DECLINED = "REGISTRATION_STATUS_DECLINED"
export const REGISTRATION_STATUS_INCOMPLETE = "REGISTRATION_STATUS_INCOMPLETE"
export const REGISTRATION_STATUS_USER_NOT_AVAILABLE = "REGISTRATION_STATUS_USER_NOT_AVAILABLE"
export const REGISTRATION_STATUS_NOT_SUBSCRIBED = "REGISTRATION_STATUS_NOT_SUBSCRIBED"
export const REGISTRATION_STATUS_ON_WAITING_LIST = "REGISTRATION_STATUS_ON_WAITING_LIST"
export const REGISTRATION_STATUS_PENDING_APPROVAL = "REGISTRATION_STATUS_PENDING_APPROVAL"
export const REGISTRATION_STATUS_UNSUBSCRIBED = "REGISTRATION_STATUS_UNSUBSCRIBED"
export const REGISTRATION_STATUS_NOT_ALLOWED = "REGISTRATION_STATUS_NOT_ALLOWED"

/* Subevent registration status */
export const SLOT_REGISTRATION_STATUS = {
  SLOT_REGISTRATION_STATUS_NOT_SUBSCRIBED: "SLOT_REGISTRATION_STATUS_NOT_SUBSCRIBED",
  SLOT_REGISTRATION_STATUS_SUBSCRIBED: "SLOT_REGISTRATION_STATUS_SUBSCRIBED",
  SLOT_REGISTRATION_STATUS_UNDEFINED_VALUE_UNSPECIFIED: "SLOT_REGISTRATION_STATUS_UNDEFINED_VALUE_UNSPECIFIED",
  SLOT_REGISTRATION_STATUS_UNSUBSCRIBED: "SLOT_REGISTRATION_STATUS_UNSUBSCRIBED",
} as const

export const SAVED = "saved"
export const SAVE = "save"
export const maxFileSizeMB = 1.5
export const LONG_TEXT_MAX_LIMIT = 8000

// Roles that have the icon button with direct access to edit the event in the BO
export const EVENT_EDITION_ROLES = [...SCHOOL_ADMIN_ROLES, ...COMPANY_ADMIN_ROLES, ...RECRUITER_ADMIN_ROLES] as const
